module.exports = __webpack_public_path__ + "res/25-img_collect_value.e0b31596aedf9d11c4959d4c23cf997c.png";